
import { defineComponent, computed } from "vue";
import DOMPurify from "dompurify";

export default defineComponent({
  name: "EmbeddedBoard",
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const rawInput = computed(() => props.resource.link.trim());
    const isIframeTag = computed(() => rawInput.value.startsWith("<iframe"));

    const safeHtml = computed(() => {
      const input = rawInput.value;
      let iframeHtml = "";

      if (isIframeTag.value) {
        iframeHtml = DOMPurify.sanitize(input, {
          ADD_TAGS: ["iframe"],
          ALLOWED_ATTR: [
            "src",
            // Fixme: For now we force width/height in css but could be change in the future
            // "width",
            // "height",
            "allow",
            "allowfullscreen",
            "frameborder",
            "sandbox",
            "referrerpolicy",
          ],
        });

        iframeHtml = iframeHtml.replace(
          /<iframe/,
          '<iframe width="100%" height="100%"',
        );

        if (!iframeHtml.includes("sandbox")) {
          iframeHtml = iframeHtml.replace(
            /<iframe/,
            '<iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms"',
          );
        }

        if (!iframeHtml.includes("referrerpolicy")) {
          iframeHtml = iframeHtml.replace(
            /<iframe/,
            '<iframe referrerpolicy="no-referrer"',
          );
        }
      } else {
        const safeUrl = DOMPurify.sanitize(input);
        iframeHtml = `
          <iframe
            src="${safeUrl}"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            referrerpolicy="no-referrer"
          ></iframe>
        `;
      }

      return iframeHtml;
    });

    return {
      safeHtml,
    };
  },
});
